// Imports
import { StripeError } from '@stripe/stripe-js';
import commonActions from '../../../foundation/front-end/redux/actions';
import store from '../../../foundation/front-end/redux/store';
import ExpectedFormError from '../../../utils/errors/expected-form-error';
import modifyStripeMessage from './modify-stripe-message';


/** Delegates what Stripe errors should be shown to users, and what errors are unexpected (and should be reported to Sentry); error messages shown to users are modified to user friendly versions first */
export default function handleStripeError(
	error: StripeError,
	setStripeError: React.Dispatch<React.SetStateAction<string>>
): void {
	// Determine if this is an error we want to show to users
	const canShowToUsers =
		error.type === 'card_error' ||
		error.type === 'validation_error' ||
		error.code === 'bank_account_unusable' ||
		(error.code === 'account_number_invalid' && error.param === 'bank_account[account_number]') ||
		(error.code === 'routing_number_invalid' && error.param === 'bank_account[routing_number]');
	
	
	// Handle if it can be shown to users
	if (canShowToUsers) {
		// Show the modified message
		setStripeError(
			modifyStripeMessage(
				error.message ??
					'Something went wrong while processing these details. Please double-check the details and try again.'
			)
		);
		
		throw new ExpectedFormError();
	}
	
	
	// Display page messages for unexpected errors
	store.dispatch(
		commonActions.showPageMessage({
			color: 'danger',
			title: 'Oh snap!',
			message: 'There was an unexpected issue.',
		})
	);
	
	
	// Rethrow errors not shown to users to be handled by a parent scope
	throw error; // eslint-disable-line @typescript-eslint/no-throw-literal
}
